const UNITS_ROUTES = {
  path: '/units',
  component: () => import('@/pages/Units/UnitsPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'units.index',
      component: () => import('@/pages/Units/UnitsPage.vue'),
    },
    {
      path: 'create',
      name: 'units.create',
      component: () => import('@/pages/Units/UnitsFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'units.edit',
      component: () => import('@/pages/Units/UnitsFormPage.vue'),
    },
  ],
};

export default UNITS_ROUTES;
